module.exports = __webpack_public_path__ + "static/img/武培瑞.0b1ba8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/st/武培瑞.jpg
// module id = nDcz
// module chunks = 1